import { cn as e } from "../../shared/utils.js";
import { Button as t } from "../../button/primitive/button.js";
import { useTranslation as n } from "../../i18n/hooks.js";
import { InputGroup as r } from "../../input/input-group.js";
import { useFormControlSize as i } from "../../form-control-size/index.js";
import { CalendarIcon as a, XIcon as o } from "@systemeio/icons";
import { useId as s } from "react";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import { Field as u } from "@base-ui/react/field";
//#region src/date-picker/primitive/date-field.tsx
var d = ({ description: d, error: f, label: p, labelClassName: m, value: h, placeholder: g, clearable: _, disabled: v, focus: y, required: b, size: x, wrapperClassName: S, inputClassName: C, className: w, onClear: T }) => {
	let { t: E } = n(), D = i(), O = x ?? D ?? "md", k = s(), A = !f && !!d, j = !!f;
	return /* @__PURE__ */ l(u.Root, {
		invalid: !!f,
		className: e("flex flex-col gap-2", S),
		children: [
			p && /* @__PURE__ */ c(u.Label, {
				className: e("text-text-secondary data-[required=true]:after:text-text-error block text-left text-base font-normal data-[required=true]:after:ml-0.5 data-[required=true]:after:content-['*']", m),
				htmlFor: k,
				"data-required": b || void 0,
				children: p
			}),
			/* @__PURE__ */ l(r.Root, {
				className: w,
				size: O,
				children: [
					_ && /* @__PURE__ */ c(r.Addon, {
						align: "inline-start",
						children: /* @__PURE__ */ c(a, { className: e("text-field-icon shrink-0", O === "sm" ? "size-4" : "size-5") })
					}),
					/* @__PURE__ */ c(r.Input, {
						id: k,
						value: h ?? "",
						className: e("pointer-events-none cursor-pointer", C),
						disabled: v,
						placeholder: g,
						readOnly: !0,
						tabIndex: -1,
						...y ? { "data-focused": "" } : {}
					}),
					/* @__PURE__ */ l(r.Addon, {
						align: "inline-end",
						className: "gap-1",
						children: [_ && h && T && /* @__PURE__ */ c(t, {
							"aria-label": E("public_pages_purchase.date_picker.clear"),
							className: "text-field-icon",
							size: "icon-sm",
							variant: "link-gray",
							disabled: v,
							onClick: (e) => {
								e.stopPropagation(), T();
							},
							children: /* @__PURE__ */ c(o, {})
						}), !_ && /* @__PURE__ */ c(a, { className: e("text-field-icon shrink-0", O === "sm" ? "size-4" : "size-5") })]
					})
				]
			}),
			j && /* @__PURE__ */ c("p", {
				className: "text-text-error text-base",
				children: f
			}),
			A && /* @__PURE__ */ c("p", {
				className: "text-text-tertiary text-base",
				children: d
			})
		]
	});
};
d.displayName = "DateField";
//#endregion
export { d as DateField };
